import React, { useState } from 'react';

import { CRM_PERMISSION } from '../../casino/pages/Helpers/CrmPermissions';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import Card from '../../elements/common/Card';

import CasinoSlidersApi from 'Api/CRM/Modules/CasinoSlidersApi';
import CasinoSliderItem from 'Api/Models/CasinoSliderItem';
import TableHead from 'crm/elements/common/TableHead';
import TableLoader from 'crm/elements/common/TableLoader';
import useNumberParams from 'crm/hooks/useNumberParams';
import useOnce from 'crm/hooks/useOnce';

function SliderShow() {
    const { id } = useNumberParams();
    const [casinoSliderItems, setCasinoSliderItems] = useState<CasinoSliderItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const updateSliderItems = () => {
        setIsLoading(true);
        CasinoSlidersApi.getItemsBySliderId(id)
            .then(setCasinoSliderItems)
            .finally(() => setIsLoading(false));
    };

    useOnce(updateSliderItems);

    const getTableBody = () =>
        casinoSliderItems.length ? (
            casinoSliderItems.map((casinoSliderItem) => (
                <tr key={casinoSliderItem.id}>
                    <td>{casinoSliderItem.id}</td>
                    <td>{casinoSliderItem.category_name}</td>
                    <td>{casinoSliderItem.limit}</td>
                    <td>
                        <EditButton
                            url={`/casino_slider_item/${casinoSliderItem.id}/`}
                            permissions={[CRM_PERMISSION.CASINO_SLIDER_ITEM_EDIT]}
                        />
                        <DeleteButton
                            url={`/crea/api/casino_slider_items/${casinoSliderItem.id}`}
                            permissions={[CRM_PERMISSION.CASINO_SLIDER_ITEM_DELETE]}
                            action={updateSliderItems}
                        />
                    </td>
                </tr>
            ))
        ) : (
            <tr>
                <td colSpan={7}>Slider doesnt have slides yet...</td>
            </tr>
        );

    return (
        <Card>
            <ActionButton
                url={`/casino-slider/${id}/create`}
                title="Add new slider item"
                permissions={[CRM_PERMISSION.CASINO_SLIDER_ITEM_CREATE]}
            />
            <TableLoader isLoading={isLoading}>
                <table className="table">
                    <TableHead>
                        <th>ID</th>
                        <th>Category Name</th>
                        <th>Limit</th>
                    </TableHead>
                    <tbody>{getTableBody()}</tbody>
                </table>
            </TableLoader>
        </Card>
    );
}

export default SliderShow;
